export default __webpack_public_path__ + "static/media/blue.eafbddab.png";